import './styles.scss';

import { useEffect, useState } from 'react';

import AccidentFormHistoryTableColumns from '@/features/AccidentHistory/components/AccidentHistoryForm/AccidentFormHistoryTable/AccidentFormHistoryTableColumns';
import AccidentFormHistoryTableRow from '@/features/AccidentHistory/components/AccidentHistoryForm/AccidentFormHistoryTable/AccidentFormHistoryTableRow';
import { AccidentHistoryFormDefinitions } from '../types';
import { AccidentHistoryRow } from '@/features/AccidentHistory';
import Provider from '@/common/Provider';
import SimpleTable from '@/components/SimpleTable';
import { refetchAccidentIssueWithDocuments } from '@/features/AccidentHistory/api/services/searchAccidentIssue';

const AccidentFormHistoryTable = ({
  onEditAccident,
  id,
  driverFirstName,
  driverLastName,
  vehicleTrackingId,
}: {
  onEditAccident?: (accident: AccidentHistoryFormDefinitions.Value) => void;
  id: string;
  driverFirstName: string;
  driverLastName: string;
  vehicleTrackingId: string;
}): JSX.Element => {
  const [{ loading, data }, setState] = useState({ loading: false, data: new Map() });
  const getHistory = async (id: string): Promise<void> => {
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await refetchAccidentIssueWithDocuments([{ id }]);
      setState((current) => {
        const data = new Map<string, AccidentHistoryRow>(res.rows.map((issue) => [issue.id, issue]));
        return { ...current, data };
      });
    } catch (err) {
      console.error('Error getting history:', err);
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  };

  useEffect((): void => {
    if (!id) return;
    getHistory(id);
  }, [id]);

  return (
    <Provider value={{ data, driverFirstName, driverLastName, vehicleTrackingId }} methods={() => ({ onEditAccident })}>
      <SimpleTable
        className="AccidentHistoryFormHistoryTable"
        rows={Array.from(data.keys())}
        columns={AccidentFormHistoryTableColumns}
        row={AccidentFormHistoryTableRow}
      />
    </Provider>
  );
};

export default AccidentFormHistoryTable;
